import { useCallback, useEffect, useRef, useState } from 'react';
import http from 'src/services/httpService';
import { FormattedMessage, useIntl } from 'react-intl';
import LoadingContainer from '../../componentes/loading-container';
import errorHandler from '../../utils/error-handler';
import { Table } from 'reactstrap';
import Avatar from '../../componentes/avatar';
import { prepareHtml } from '../../utils/html';
import { format, isValid } from 'date-fns';
import formatDateFns from 'src/utils/formatDateFns';
import Pagination from 'src/componentes/list/pagination';

const DEFAULT_PAGE_SIZE = 5;
const PAGE_SIZE_OPTIONS = [5, 10, 20, 40];

function Versao({
  url,
  id,
  entidadeId,
  funcionalidadeId,
  refreshToken,
  onTotalLoaded,
}) {
  const intl = useIntl();
  const [alteracoes, setAlteracoes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const onTotalLoadedRef = useRef(onTotalLoaded);

  useEffect(() => {
    onTotalLoadedRef.current = onTotalLoaded;
  }, [onTotalLoaded]);

  const carregar = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await http.post(url, {
        id,
        entidadeId,
        funcionalidadeId,
      });

      setAlteracoes(response.data.alteracoes ?? []);
      setCurrentPage(1);

      if (onTotalLoadedRef.current) {
        onTotalLoadedRef.current(response.data.QuantidadeTotal);
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  }, [url, id, entidadeId, funcionalidadeId]);

  useEffect(() => {
    carregar();
  }, [carregar, refreshToken]);

  const changePageSize = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const renderData = (dataHora) => {
    if (!isValid(new Date(dataHora))) {
      return intl.formatMessage({ id: 'dataNaoDefinida' });
    }

    const { locale } = intl;
    const { currentLocale } = formatDateFns(locale);

    return format(new Date(dataHora), 'Pp', { locale: currentLocale });
  };

  const renderAlteracao = (alteracao, alteracaoIndex) => {
    return (
      <div key={alteracaoIndex} style={{ padding: 10 }}>
        <div
          style={{
            marginBottom: 5,
            display: 'inline-flex',
            justifyContent: 'center',
          }}
        >
          <Avatar
            foto={alteracao && alteracao.fotoArquivo}
            size={23}
            label={alteracao.usuario}
          ></Avatar>{' '}
          <span style={{ verticalAlign: 'middle', marginLeft: 5 }}>
            - {renderData(alteracao.dataHora)}
          </span>
        </div>
        <Table size="sm" bordered>
          <thead>
            <tr>
              <th style={{ width: '33%' }}>
                {<FormattedMessage id="label.campo" />}
              </th>
              <th style={{ width: '33%' }}>
                {<FormattedMessage id="label.valorAntigo" />}
              </th>
              <th style={{ width: '33%' }}>
                {<FormattedMessage id="label.valorNovo" />}
              </th>
            </tr>
          </thead>
          <tbody>
            {alteracao.alteracoesCampos.map(
              (alteracaoCampo, alteracaoCampoIndex) => (
                <tr key={alteracaoCampoIndex}>
                  <td>{alteracaoCampo.campo}</td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={prepareHtml(
                        alteracaoCampo.valorAnterior
                      )}
                    ></div>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={prepareHtml(
                        alteracaoCampo.novoValor
                      )}
                    ></div>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </Table>
        <br></br>
      </div>
    );
  };

  const renderAlteracoes = () => {
    const startIndex = (currentPage - 1) * pageSize;

    return alteracoes
      .slice(startIndex, startIndex + pageSize)
      .map((alteracao, alteracaoIndex) =>
        renderAlteracao(alteracao, startIndex + alteracaoIndex)
      );
  };

  const renderSemAlteracoes = () => {
    return (
      <div>
        <p>{<FormattedMessage id="label.nenhumaAlteracaoRealizada" />}</p>
      </div>
    );
  };

  return (
    <LoadingContainer isLoading={isLoading}>
      {alteracoes.length ? renderAlteracoes() : renderSemAlteracoes()}
      {alteracoes.length > DEFAULT_PAGE_SIZE && (
        <div className="d-flex justify-content-end mt-3">
          <Pagination
            count={alteracoes.length}
            currentPage={currentPage}
            pageSize={pageSize}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            changeCurrentPage={setCurrentPage}
            changePageSize={changePageSize}
            onRefreshClick={carregar}
          />
        </div>
      )}
    </LoadingContainer>
  );
}

export default Versao;
